export default {
    path: 'toppings',
    component: () => import('../Model.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách topping',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo topping',
            component: () => import('../cu/CU.vue'),
        },
        {
            path: 'cu/:id',
            name: 'Chi tiết topping',
            component: () => import('../cu/CU.vue'),
        },
    ]
};